import { render, staticRenderFns } from "./SoPlushButton.vue?vue&type=template&id=a41eca92&scoped=true&lang=pug&"
import script from "./SoPlushButton.vue?vue&type=script&lang=ts&"
export * from "./SoPlushButton.vue?vue&type=script&lang=ts&"
import style0 from "./SoPlushButton.vue?vue&type=style&index=0&id=a41eca92&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41eca92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
